var exports = {
  "SP": "PollCard.module__pollCard___M05zOE",
  "J_": "PollCard.module__pollHeader___M05zOE",
  "FR": "PollCard.module__questionRow___M05zOE",
  "$P": "PollCard.module__pollIcon___M05zOE",
  "mD": "PollCard.module__questionText___M05zOE",
  "qS": "PollCard.module__badge___M05zOE",
  "Oi": "PollCard.module__badgeClosed___M05zOE",
  "f9": "PollCard.module__optionsList___M05zOE",
  "AP": "PollCard.module__optionButton___M05zOE",
  "i8": "PollCard.module__optionButtonVoted___M05zOE",
  "hr": "PollCard.module__progressBar___M05zOE",
  "bN": "PollCard.module__progressBarVoted___M05zOE",
  "bZ": "PollCard.module__optionContent___M05zOE",
  "ts": "PollCard.module__optionLeft___M05zOE",
  "oK": "PollCard.module__optionEmoji___M05zOE",
  "re": "PollCard.module__optionText___M05zOE",
  "MU": "PollCard.module__optionRight___M05zOE",
  "Oo": "PollCard.module__voteCount___M05zOE",
  "mO": "PollCard.module__voteCountVoted___M05zOE",
  "M_": "PollCard.module__voteIndicator___M05zOE",
  "y4": "PollCard.module__voteIndicatorActive___M05zOE",
  "xV": "PollCard.module__pollFooter___M05zOE",
  "PU": "PollCard.module__footerLeft___M05zOE",
  "SA": "PollCard.module__footerStat___M05zOE",
  "rW": "PollCard.module__endPollButton___M05zOE",
};

module.exports = exports;
